export default class ModalSearchEnum {
    static BODY = 'body'
    static TRIGGER = '[data-trigger="customer-modal-search"]'
    static MODAL_SEARCH = '[data-element="customer-modal-search"]'
    static MODAL_SEARCH_BACKGROUND = '[data-element="customer-modal-search_background"]'
    static MODAL_SEARCH_INPUT = '[data-element="customer-modal-search-input"]'
}
